module.exports = require("nearley");